import { snakeStore, DATA, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { DataBaseService } from '@db/services/DataBaseService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => DataBaseService.getList(params),
      updateItemById: ({ getters, commit }, value) => {
        commit(
          DATA,
          [...getters[DATA]].map(i => {
            return i.id === value.id ? { ...i, ...value } : i;
          })
        );
      }
    }
  },
  true
);
